'use client';

import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import limitArraySize from '@module/helpers/sidebar/limitArraySize';
import { useFetchWebMainInfoQuery } from '@module/queries/main/mainQueryHooks';
import useGoPlay from '@pc/hooks/play/useGoPlay';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import BJListItem from './BJListItem';

function PickContainer() {
  const { data: mainInfo } = useFetchWebMainInfoQuery();
  const [isOpenPickPanel, setIsOpenPickPanel] = useState(false);

  const pathName = usePathname();
  const splitPath = pathName.split('/');
  const mediaId = splitPath[splitPath.length - 1];

  const { isLogin } = useGetLoginInfoQuery();
  const { goPlay } = useGoPlay();

  const pickList = limitArraySize({
    array: mainInfo?.pick || [],
    shouldExpand: isOpenPickPanel,
  });

  const scrollTopHandler = () => {
    if (typeof window === 'undefined') return;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    if (!isLogin || !mainInfo?.pick || mainInfo?.pick.length === 0) return;
    const pickListElement = document.getElementById('sidebar-picklist');
    if (!pickListElement) return;
    pickListElement.style.transition = 'max-height 0.5s cubic-bezier(.63,.27,.5,.7), padding 0.5s ease-out';
    pickListElement.style.display = 'block'; // display 먼저 설정
    setTimeout(() => {
      pickListElement.style.maxHeight = `${mainInfo.pick.length * 50 + 500}px`; // 마지막에 maxHeight 설정
    }, 100); // CSS가 적용되기 위해 짧은 딜레이 추가
  }, [mainInfo?.pick, isLogin]);

  if (!isLogin || pickList.length === 0) return null;

  return (
    <div
      id='sidebar-picklist'
      className='max-h-14 overflow-hidden border-borderBg01 border-b px-2 pt-[17px] pb-[20px] transition-max-height duration-500 ease-out'
    >
      <div className='pointer-events-none flex w-full items-center'>
        <h2 className='flex-1 pl-[15px] text-left font-medium text-[15px] leading-[21px] tracking-[-0.5px]'>
          {'PICK'}
        </h2>
      </div>
      <div className='flex flex-col gap-[10px] pt-[5px]'>
        <ul>
          {pickList.length > 0 &&
            pickList.map((item) => {
              return (
                <BJListItem
                  key={item.userIdx}
                  onClick={() => {
                    if (mediaId === item.userId) {
                      scrollTopHandler();
                      return;
                    }
                    goPlay(item);
                  }}
                  isLive={item.isLive}
                  title={item.title}
                  userImg={item.userImg}
                  userNick={item.userNick}
                />
              );
            })}
        </ul>
        {mainInfo?.pick && mainInfo.pick.length > 5 && (
          <button
            type='button'
            className='flex h-[26px] w-full items-center gap-[30px] px-[25px] text-left text-[15px] leading-[21px] tracking-[-0.5px]'
            aria-expanded='false'
            onClick={() => {
              setIsOpenPickPanel((prevState) => !prevState);
            }}
          >
            {isOpenPickPanel ? (
              <FontAwesomeIcon icon={faChevronUp} className='h-[10px] w-[10px] shrink-0' />
            ) : (
              <FontAwesomeIcon icon={faChevronDown} className='h-[10px] w-[10px] shrink-0' />
            )}
            <span>{isOpenPickPanel ? '간략히 보기' : `${(mainInfo.pick?.length || 0) - 5}${'개 더보기'}`}</span>
          </button>
        )}
      </div>
    </div>
  );
}

export default PickContainer;
